/**
 * @generated SignedSource<<5cb0f9e844b8ed49be36f20a1c3e29ea>>
 * @relayHash f15bd8b5d1ef27139fdf753918230146
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionDetailsDesignRefetchableQuery$variables = {
  after?: string | null | undefined;
  cloudAri: string;
  first?: number | null | undefined;
  id: string;
};
export type versionDetailsDesignRefetchableQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"designCarousel_versionIssueAssociatedDesigns">;
  } | null | undefined;
};
export type versionDetailsDesignRefetchableQuery = {
  response: versionDetailsDesignRefetchableQuery$data;
  variables: versionDetailsDesignRefetchableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudAri"
  },
  {
    "defaultValue": 6,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": {
      "createdAt": {
        "direction": "DESC",
        "priority": 1
      }
    }
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "versionDetailsDesignRefetchableQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "designCarousel_versionIssueAssociatedDesigns"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "versionDetailsDesignRefetchableQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                "kind": "LinkedField",
                "name": "issueAssociatedDesigns",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastUpdated"
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "cloudAri"
                                  }
                                ],
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "logoUrl"
                                  },
                                  (v5/*: any*/)
                                ]
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                  }
                                ],
                                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                "kind": "LinkedField",
                                "name": "associatedIssues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "key"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                              },
                                              {
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "idsOrAliases",
                                                    "value": [
                                                      "issuetype",
                                                      "summary"
                                                    ]
                                                  },
                                                  {
                                                    "kind": "Literal",
                                                    "name": "ignoreMissingFields",
                                                    "value": true
                                                  }
                                                ],
                                                "kind": "LinkedField",
                                                "name": "fieldsByIdOrAlias",
                                                "plural": true,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                          },
                                                          {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "xsmall"
                                                              }
                                                            ]
                                                          },
                                                          (v5/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "text"
                                                      }
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                  },
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                              }
                                            ],
                                            "type": "JiraIssue"
                                          },
                                          (v4/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      },
                                      (v5/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": "associatedIssues(first:2)"
                              }
                            ],
                            "type": "DevOpsDesign"
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v6/*: any*/),
                "filters": [
                  "sort"
                ],
                "handle": "connection",
                "key": "DesignSlider_issueAssociatedDesigns",
                "kind": "LinkedHandle",
                "name": "issueAssociatedDesigns"
              }
            ],
            "type": "JiraVersion"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672",
    "metadata": {},
    "name": "versionDetailsDesignRefetchableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7979312fd2183c859bc266fe0defac6d";

export default node;
